import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/web.dom-collections.iterator.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers } from "vue";
var _hoisted_1 = ["id"];
var _hoisted_2 = ["id", "data-cy"];
var _hoisted_3 = ["data-idx", "loading", "alt", "width", "height", "onLoad"];
var _hoisted_4 = ["id"];
var _hoisted_5 = ["loading", "alt"];
import { Swiper } from "swiper";
import { Zoom } from "swiper/modules";
// import Swiper and modules styles
import "swiper/css/bundle";
//Zoom module not only allow us to auto center the images, but it will also center the images!
import "swiper/css/zoom";
//@ts-ignore
import { shallowCopyObjectTo } from "@utils/ObjectUtils";
import { reactive, computed, onMounted, ref, nextTick } from "vue";
export default /*#__PURE__*/_defineComponent(Object.assign({
  inheritAttrs: false
}, {
  __name: 'SwiperCarousel',
  props: {
    id: {},
    swiperOptions: {},
    thumbSwiperOptions: {},
    lazyLoadImages: {
      type: Boolean,
      default: true
    },
    backgroundImage: {
      type: Boolean,
      default: false
    },
    images: {},
    artDirection: {},
    shiftFirstImage: {
      type: Boolean,
      default: false
    },
    customLastSlide: {
      type: Boolean,
      default: false
    }
  },
  emits: ["moved", "click", "firstSlideLoaded"],
  setup(__props, _ref) {
    var {
      expose: __expose,
      emit: __emit
    } = _ref;
    //@ts-ignore
    var props = __props;
    var emits = __emit;
    var state = reactive({
      swiperParams: {
        modules: [Zoom]
      },
      swiper: null,
      initCarousel: false
    });
    var swiperWrapper = ref();
    var sliderSlidePerView = computed(() => {
      var _a;
      return ((_a = props.swiperOptions) === null || _a === void 0 ? void 0 : _a.slidesPerView) || 1;
    });
    var thumbSlidePerView = computed(() => {
      var _a;
      return ((_a = props.thumbSwiperOptions) === null || _a === void 0 ? void 0 : _a.slidesPerView) || 1;
    });
    var keyboardControl = computed(() => {
      var _a;
      return !!((_a = props.swiperOptions) === null || _a === void 0 ? void 0 : _a.keyboard);
    });
    var navigation = computed(() => {
      var swiperOptions = props.swiperOptions;
      if (!swiperOptions) return false;
      return !!swiperOptions.navigation;
    });
    var pagination = computed(() => {
      var swiperOptions = props.swiperOptions;
      if (!swiperOptions) return false;
      return !!swiperOptions.pagination;
    });
    var autoplay = computed(() => {
      var swiperOptions = props.swiperOptions;
      if (!swiperOptions) return false;
      return !!swiperOptions.autoplay;
    });
    var effect = computed(() => {
      var _a;
      return ((_a = props.swiperOptions) === null || _a === void 0 ? void 0 : _a.effect) || "slider";
    });
    var setSwiperOptions = () => {
      if (!props.swiperOptions) return;
      shallowCopyObjectTo(props.swiperOptions, state.swiperParams);
    };
    var imgAttributes = function imgAttributes(image) {
      var idx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
      if (!image.images)
        //By default, we will use the src given in input
        return {
          src: image.src || ""
        };
      var src = "";
      var srcset = "";
      var sizes = "";
      if (props.artDirection) {
        for (var bp in props.artDirection) {
          var {
            mq,
            width
          } = props.artDirection[bp];
          if (!width) continue;
          sizes += sizes ? ",".concat(mq, " ").concat(parseInt(width), "px") : "".concat(mq, " ").concat(parseInt(width), "px");
        }
        srcset = image.images.reduce((acc, img, idx) => {
          var bp = Object.values(props.artDirection)[idx];
          if (!bp || !bp.width) return acc;
          acc += acc ? ", ".concat(img.storagePath, " ").concat(bp.width) : "".concat(img.storagePath, " ").concat(bp.width);
          return acc;
        }, "");
        src = image.images[0].storagePath;
      } else {
        /* Special case: insertion  */
        var images = image.images;
        if (image.images.length > 3) images = image.images.slice(2, 5);else {
          if (props.shiftFirstImage)
            //Shifting the first image since it has too low resolution
            images[0] = images[1];
        }
        srcset = images.reduce((acc, img, idx) => {
          if (idx === 0) src = "".concat(img.storagePath);
          if (idx > 0) acc += ", ";
          return "".concat(acc).concat(img.storagePath, " ").concat(idx + 1, "x");
        }, "");
      }
      //Preparing manual lazy loading
      var dataSrc = src;
      var dataSrcset = srcset;
      if (typeof sliderSlidePerView.value === "number" && idx > sliderSlidePerView.value) {
        src = "";
        srcset = "";
        return {
          sizes,
          ["data-src"]: dataSrc,
          ["data-srcset"]: dataSrcset
        };
      } else {
        return {
          src,
          srcset,
          sizes
        };
      }
    };
    var imagesRefs = [];
    var handleMovedSlide = curIndex => {
      var _a;
      if (typeof sliderSlidePerView.value == "string") return;
      var curImg = imagesRefs[curIndex];
      //It may happen that, when having the thumbnail, the current image has not been loaded yet...
      if (curImg && !curImg.src) {
        curImg.src = curImg.dataset.src || "";
        curImg.srcset = curImg.dataset.srcset || "";
      }
      if (curIndex < sliderSlidePerView.value || curIndex + 1 >= ((_a = props.images) !== null && _a !== void 0 ? _a : []).length) return;
      //Manually loading the x + 1 slide
      var img = imagesRefs[curIndex + 1];
      if (img && !img.src) {
        img.src = (img === null || img === void 0 ? void 0 : img.dataset.src) || "";
        img.srcset = (img === null || img === void 0 ? void 0 : img.dataset.srcset) || "";
      }
    };
    __expose({
      moveTo(index) {
        var speed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var runCallbacks = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
        state.swiper && state.swiper.slideTo(index, speed, runCallbacks);
      }
    });
    var root = ref(null);
    var handleLoad = idx => {
      if (idx === 0 && imagesRefs && imagesRefs[idx]) nextTick(() => {
        var _a;
        //Setting a data-attribute to the root element to get the info about the first loaded element
        (_a = root.value) === null || _a === void 0 ? void 0 : _a.setAttribute("data-first-slide-loaded", "true");
        emits("firstSlideLoaded");
      });
    };
    onMounted(() => __awaiter(this, void 0, void 0, function* () {
      var _a, _b, _c, _d, _e, _f, _g, _h, _j;
      setSwiperOptions();
      if (keyboardControl.value) {
        var {
          Keyboard
        } = yield import("swiper/modules");
        (_a = state.swiperParams.modules) === null || _a === void 0 ? void 0 : _a.push(Keyboard);
        state.swiperParams.keyboard = props.swiperOptions.keyboard;
      }
      if (pagination.value) {
        var {
          Pagination
        } = yield import("swiper/modules");
        (_b = state.swiperParams.modules) === null || _b === void 0 ? void 0 : _b.push(Pagination);
        /* Importing pagination CSS */
        //@ts-ignore
        yield import("swiper/css/pagination");
        /* Importing definitions */
        state.swiperParams.pagination = Object.assign({
          el: ".swiper-pagination",
          renderFraction: (currentClass, totalClass) => "<div class=\"tw-rounded-xs tw-border-w-black tw-border tw-border-solid tw-px-3 tw-bg-white tw-pt-[3px] tw-pb-[3px]\">\n                    <span data-cy=\"swiper-pagination-current\" class=\"".concat(currentClass, "\"></span>\n                    /\n                    <span data-cy=\"swiper-pagination-total\" class=\"").concat(totalClass, "\"></span>\n                 </div>")
        }, state.swiperParams.pagination);
      }
      if (navigation.value) {
        var {
          Navigation
        } = yield import("swiper/modules");
        (_c = state.swiperParams.modules) === null || _c === void 0 ? void 0 : _c.push(Navigation);
        /* Importing pagination */
        //@ts-ignore
        yield import("swiper/css/navigation");
        var navigationClasses = Object.assign(Object.assign({}, (_d = props.swiperOptions.navigation.nextEl) !== null && _d !== void 0 ? _d : {
          nextEl: ".swiper-button-next"
        }), (_e = props.swiperOptions.navigation.prevEl) !== null && _e !== void 0 ? _e : {
          prevEl: ".swiper-button-prev"
        });
        state.swiperParams.navigation = Object.assign(Object.assign({}, props.swiperOptions.navigation), navigationClasses);
      }
      if (autoplay.value) {
        var {
          Autoplay
        } = yield import("swiper/modules");
        (_f = state.swiperParams.modules) === null || _f === void 0 ? void 0 : _f.push(Autoplay);
        //@ts-ignore
        yield import("swiper/css/autoplay");
        state.swiperParams.autoplay = props.swiperOptions.autoplay;
      }
      /* The props of the main slider */
      var sliderProps = Object.assign(Object.assign({}, state.swiperParams), {
        on: {
          slideChange: swiper => {
            handleMovedSlide(swiper.activeIndex);
            emits("moved", {
              activeIndex: swiper.activeIndex
            });
          }
        }
      });
      /* Initializing thumb so we can pass it to the main swiper */
      var thumbSwiper = null;
      if (props.thumbSwiperOptions) {
        var {
          Thumbs,
          FreeMode,
          Controller
        } = yield import("swiper/modules");
        (_g = state.swiperParams.modules) === null || _g === void 0 ? void 0 : _g.push(Thumbs);
        (_h = state.swiperParams.modules) === null || _h === void 0 ? void 0 : _h.push(Controller);
        /* Importing css */
        //@ts-ignore
        yield import("swiper/css/thumbs");
        //@ts-ignore
        yield import("swiper/css/free-mode");
        //@ts-ignore
        yield import("swiper/css/controller");
        thumbSwiper = new Swiper("#thumb_".concat(props.id), Object.assign(Object.assign({}, props.thumbSwiperOptions), {
          modules: [FreeMode]
        }));
        sliderProps.thumbs = {
          swiper: thumbSwiper
        };
      }
      sliderProps.lazyPreloadPrevNext = 1;
      state.swiper = new Swiper("#".concat(props.id), sliderProps);
      //In case the swiper wrapper has tw-hidden (useful to avoid showing the first image in a modal gallery) we need to remove it
      //when the carousel has loaded
      (_j = swiperWrapper.value) === null || _j === void 0 ? void 0 : _j.classList.remove("tw-hidden");
    }));
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        id: "root-".concat(_ctx.id),
        ref_key: "root",
        ref: root,
        class: _normalizeClass(["swiper-carousel-root", _ctx.$attrs['root-classes']])
      }, [_createCommentVNode(" Slider main container "), _createElementVNode("div", {
        id: _ctx.id,
        "data-cy": _ctx.$attrs['data-cy'],
        class: _normalizeClass(["swiper", _ctx.$attrs['swiper-classes']])
      }, [_createCommentVNode(" Additional required wrapper "), _createElementVNode("div", {
        ref_key: "swiperWrapper",
        ref: swiperWrapper,
        class: _normalizeClass(["swiper-wrapper", [_ctx.$attrs['swiper-wrapper-classes'], effect.value === 'none' && 'no-transition']]),
        onClick: _cache[0] || (_cache[0] = $event => emits('click'))
      }, [_createCommentVNode(" Slides "), _renderSlot(_ctx.$slots, "swiper_slide", {}, () => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (image, idx) => {
        return _openBlock(), _createElementBlock("div", {
          key: "swiper_".concat(_ctx.id, "_").concat(idx),
          class: _normalizeClass(["swiper-slide", _ctx.$attrs['swiper-slide-classes']])
        }, [_createElementVNode("div", {
          class: _normalizeClass(["swiper-zoom-container", _ctx.$attrs['swiper-zoom-container-classes']])
        }, [!_ctx.backgroundImage ? (_openBlock(), _createElementBlock("img", _mergeProps({
          key: 0,
          ref_for: true,
          ref: el => imagesRefs.push(el),
          class: ["disable-select", [_ctx.$attrs['slide-img-classes'] || image.classes]],
          "data-idx": "".concat(_ctx.id, "-slide-img-").concat(idx)
        }, imgAttributes(image, idx), {
          loading: _ctx.lazyLoadImages ? 'lazy' : idx >= sliderSlidePerView.value ? 'lazy' : '',
          alt: image.alt,
          itemprop: "image",
          width: image.width,
          height: image.height,
          onLoad: $event => handleLoad(idx)
        }), null, 16 /* FULL_PROPS */, _hoisted_3)) : _createCommentVNode("v-if", true)], 2 /* CLASS */)], 2 /* CLASS */);
      }), 128 /* KEYED_FRAGMENT */)), _ctx.customLastSlide ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["swiper-slide", [_ctx.$attrs['swiper-slide-classes'], _ctx.$attrs['swiper-last-slide-classes']]])
      }, [_renderSlot(_ctx.$slots, "last-slide")], 2 /* CLASS */)) : _createCommentVNode("v-if", true)])], 2 /* CLASS */), _createCommentVNode(" If we need pagination "), pagination.value ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass([_ctx.$attrs['swiper-pagination-classes'], "swiper-pagination [&.swiper-pagination-fraction]:tw-flex [&.swiper-pagination-fraction]:tw-justify-center"]),
        onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
      }, null, 2 /* CLASS */)) : _createCommentVNode("v-if", true), _createCommentVNode(" If we need navigation buttons "), navigation.value ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createElementVNode("div", {
        class: "swiper-button-prev",
        "data-cy": "swiper-button-prev",
        onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
      }), _createElementVNode("div", {
        class: "swiper-button-next",
        "data-cy": "swiper-button-next",
        onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
      })], 64 /* STABLE_FRAGMENT */)) : _createCommentVNode("v-if", true), _createCommentVNode(" If we need scrollbar "), _createCommentVNode("    <div class=\"swiper-scrollbar\" />")], 10 /* CLASS, PROPS */, _hoisted_2), _ctx.thumbSwiperOptions ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        id: "thumb_".concat(_ctx.id),
        thumbsSlider: "",
        class: _normalizeClass(["swiper", _ctx.$attrs['thumb-swiper-classes']])
      }, [_createElementVNode("div", {
        class: _normalizeClass(["swiper-wrapper", _ctx.$attrs['thumb-swiper-wrapper-classes']])
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (image, idx) => {
        return _openBlock(), _createElementBlock("div", {
          key: "thumb_".concat(_ctx.id, "_").concat(idx),
          class: _normalizeClass(["swiper-slide", _ctx.$attrs['thumb-img-wrapper-classes']])
        }, [_createElementVNode("img", _mergeProps({
          class: _ctx.$attrs['thumb-img-classes'],
          ref_for: true
        }, imgAttributes(image), {
          loading: idx >= thumbSlidePerView.value ? 'lazy' : '',
          alt: image.alt
        }), null, 16 /* FULL_PROPS */, _hoisted_5)], 2 /* CLASS */);
      }), 128 /* KEYED_FRAGMENT */))], 2 /* CLASS */)], 10 /* CLASS, PROPS */, _hoisted_4)) : _createCommentVNode("v-if", true)], 10 /* CLASS, PROPS */, _hoisted_1);
    };
  }
}));